import { useState } from 'react';
import { Button } from '@/components/Button';
import { Overlay } from './ListKit';
import s from './FilterSheet.module.css';

export type FilterOpt = { value: string; label: string; count?: number };
export type FilterGroup = { key: string; title: string; opts: FilterOpt[]; /** 这一组必须有值（如时间范围），点已选项不会取消 */ required?: boolean; hint?: string };

/**
 * 更多筛选（通用版，订单模块 FilterPanel 的去业务化版本）：手机是全高底部 sheet，iPad / 桌面是右侧抽屉（文档 23 §6）。
 * 每组单选（老接口每个参数只收一个值）；应用后写进 URL。
 */
export function FilterSheet({ groups, value, onApply, onClose, sheet, note }: { groups: FilterGroup[]; value: Record<string, string | undefined>; onApply: (v: Record<string, string | undefined>) => void; onClose: () => void; sheet: boolean; note?: string }) {
  const [f, setF] = useState<Record<string, string | undefined>>(value);
  const picked = groups.filter((g) => !g.required && f[g.key]).length;
  const reset = () => setF(Object.fromEntries(groups.map((g) => [g.key, g.required ? value[g.key] : undefined])));
  return (
    <Overlay
      sheet={sheet}
      title="筛选"
      onClose={onClose}
      headerRight={<button type="button" className={s.reset} onClick={reset}>重置</button>}
      footer={<Button variant="primary" size="lg" block onClick={() => onApply(f)}>应用{picked ? `（${picked} 项）` : ''}</Button>}
    >
      <div className={s.bd}>
        {groups.map((g) => g.opts.length > 0 && (
          <section key={g.key} className={s.sec}>
            <h4>{g.title}{!g.required && f[g.key] && <span>已选 1</span>}</h4>
            {g.hint && <p className={s.hint}>{g.hint}</p>}
            <div className={s.chips}>
              {g.opts.map((o) => {
                const on = f[g.key] === o.value;
                return (
                  <button key={o.value} type="button" className={`${s.chip} ${on ? s.on : ''}`} aria-pressed={on}
                    onClick={() => setF({ ...f, [g.key]: on && !g.required ? undefined : o.value })}>
                    {o.label}{o.count != null && <i className="tnum">{o.count}</i>}
                  </button>
                );
              })}
            </div>
          </section>
        ))}
        {note && <p className={s.note}>{note}</p>}
      </div>
    </Overlay>
  );
}
